export default __webpack_public_path__ + "static/media/BANANA.1e5f2c3d.png";